app.directive('productSetBasketOverview', [
  'productService',
  '$filter',
  'imageService',
  '$lightbox',
  '$uibModal',
  'productSetService',
  function (
    productService,
    $filter,
    imageService,
    $lightbox,
    $uibModal,
    productSetService,
  ) {
    return {
      restrict: 'E',
      templateUrl:
        '/themes/v1/default/views/templates.product-set-basket-overview.html',
      link: function (scope) {
        scope.productService = productService;
        scope.childProducts = scope.product?.child_products || [];
        scope.basketCartItems = [];

        function init() {
          const childProductWithoutVariants = scope.childProducts.filter(
            (childProduct) =>
              !childProduct.variations || childProduct.variations?.length === 0,
          );
          if (childProductWithoutVariants.length > 0) {
            // auto add product to basket if no variants
            childProductWithoutVariants.forEach((childProduct) => {
              scope.basketCartItems.push({
                ...childProduct,
                quantity: childProduct.bundle_set?.min_quantity || 0,
              });
            });
            prepareSelectedProductSetData();
            prepareChildproductData();
          }

          if (
            childProductWithoutVariants.length === scope.childProducts.length
          ) {
            // all childProducts are done selected
            scope.state.productSetCheckoutReady = true;
            scope.product.productSetCheckoutPrice = productSetService.getCheckoutPrice(
              {
                product: scope.product,
                basketCartItems: scope.basketCartItems,
              },
            );
            scope.state.checkoutReady =
              scope.product.productSetCheckoutPrice.cents > 0;
          }
        }

        init();

        scope.editProductSet = function () {
          const newScope = scope.$new();
          newScope.product = scope.product;
          newScope.childProducts = scope.childProducts;
          newScope.basketCartItems = _.clone(scope.basketCartItems);
          const modal = $uibModal.open({
            templateUrl:
              '/themes/v1/default/views/templates.product-set-basket.html',
            windowClass: 'basket-page-modal-window',
            controller: 'ProductSetBasketController',
            scope: newScope,
            keyboard: false,
          });

          modal.result.then((res) => {
            if (!res) return;
            scope.product.productSetCheckoutPrice = res.checkoutPrice;
            scope.state.checkoutReady =
              scope.product.productSetCheckoutPrice.cents > 0;
            scope.basketCartItems = res.basketCartItems;
            scope.state.productSetCheckoutReady = true;
            prepareSelectedProductSetData();
            prepareChildproductData();
          });
        };

        function prepareSelectedProductSetData() {
          scope.selectedProductSetData = scope.basketCartItems.map((item) => {
            return {
              child_product_id: item._id,
              child_variation_id: item.variationSelected
                ? item.variationSelected.key
                : null,
              quantity: item.quantity,
            };
          });
        }

        function prepareChildproductData() {
          scope.childProducts.forEach((childProduct) => {
            const productId = childProduct._id;
            if (childProduct.field_titles?.length > 0) {
              // if has variants
              const matchedItems = scope.basketCartItems.filter(
                (item) => productId === item._id,
              );
              childProduct.variationSelected = matchedItems.map((item) => {
                return {
                  ...item.variationSelected,
                  quantity: item.quantity,
                };
              });
            } else {
              // if no variants
              const matchedItem = scope.basketCartItems.find(
                (item) => productId === item._id,
              );
              childProduct.selectedQuantity = matchedItem.quantity;
            }
          });
        }

        scope.getImage = function (childProductIndex) {
          const targetChildProduct = scope.childProducts[childProductIndex];
          const media = targetChildProduct.media[0];
          return {
            media,
            url: imageService.getMediaImageUrl(media, { size: '200x' }),
          };
        };

        scope.onProductImageClicked = function (childProductIndex) {
          $lightbox.open([scope.getImage(childProductIndex).media], 0);
        };

        scope.getChildVariationName = productSetService.getChildVariationName;

        scope.isProductReachMinQuantity = function (childProduct) {
          if (scope.basketCartItems.length === 0) return false;
          const itemQuantity = scope.basketCartItems
            .filter((item) => item._id === childProduct._id)
            .reduce((accu, curr) => {
              return accu + curr.quantity;
            }, 0);

          return itemQuantity >= childProduct.bundle_set?.min_quantity;
        };

        scope.isProductOutOfStock = function (childProduct) {
          return !productSetService.checkChildProductStock(childProduct);
        };

        scope.isAllWithoutVariation = function () {
          return scope.childProducts.every(
            (childProduct) => childProduct.variations.length === 0,
          );
        };
      },
    };
  },
]);
